import { TaskResult, ValidationResult } from "./get-subject-list-response-data";

export enum SubjectUiStatusEnum {
    Draft = "Draft",
    PendingChanges = "PendingChanges",
    Published = "Published",
    FetchedWithFindings = "FetchedWithFindings",
    PublishPending = "PublishPending",
    PublishFailed = "PublishFailed",
    DeletePending = "DeletePending",
    DeleteFailed = "DeleteFailed",
    Deleted = "Deleted",
    Fetched = "Fetched",
    PublishInProgress = "PublishInProgress",
    DeleteInProgress = "DeleteInProgress"
}

export interface PublishedSubjectListItem {
    uri?: string;
    lastEdited?: string;
    values: Record<string, string | null>;
    valueLabels?: Record<string, string | null>;
    uiStatus: SubjectUiStatusEnum;
    validationResults?: ValidationResult[];
    taskResults?: TaskResult[];
    label: string;
}

export interface GetPublishedSubjectListResponseData {
    total: number;
    variables: string[];
    subjects: PublishedSubjectListItem[];
}
